module.exports = __webpack_public_path__ + "img/qrcode-icon.39d6d74a.png";